import * as React from "react";
import { Clock, Heart, Shield, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
export default function NursingCaregiverInRehovotImmediateSolution() {
  return <section id="מטפל-סיעודי-ברחובות-פתרון-מיידי" className="relative bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-96 h-96 bg-primary/5 rounded-lg blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-[30rem] h-[30rem] bg-secondary/5 rounded-lg blur-3xl pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="flex flex-col items-start text-right order-2 lg:order-1">
            <Badge variant="secondary" className="mb-6 text-sm px-3 py-1">
              <Clock className="w-4 h-4 ml-2" />
              זמינות מיידית - 24/7
            </Badge>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-foreground leading-tight mb-6">
              מטפל סיעודי ברחובות <span className="text-primary">תוך 5 שעות</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground font-default mb-8 max-w-2xl leading-relaxed">
              אנו מבינים שברגעי משבר, זמן הוא קריטי. הצוות המקצועי שלנו מספק שירותי סיעוד, השגחה ותמיכה ברחובות והסביבה, עם התחייבות להגעה מהירה של מטפל מוסמך ומסור עד לביתכם או לבית החולים.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto text-base">
                <Link to="/CaregiverServicePagesPage">
                  <Heart className="w-5 h-5 ml-2" />
                  מטפל סיעודי בבית
                </Link>
              </Button>
              
              <Button asChild variant="secondary" size="lg" className="w-full sm:w-auto text-base">
                <Link to="/ServicesCitiesArticlesPage">
                  <Shield className="w-5 h-5 ml-2" />
                  השגחה בבית חולים
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base">
                <Link to="/NursingCareProviderRehovotPage">
                  <MapPin className="w-5 h-5 ml-2" />
                  שירותים נוספים ברחובות
                </Link>
              </Button>
            </div>

            <div className="mt-10 flex items-center gap-6 text-sm text-muted-foreground font-default">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-lg" />
                <span>צוות זמין כעת</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-primary rounded-lg" />
                <span>מטפלים מוסמכים</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative order-1 lg:order-2">
            <div className="relative aspect-[4/3] md:aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl border border-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/caregiver_rehovot_hero_main.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/caregiver_rehovot_hero_main.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/caregiver_rehovot_hero_main.png-wvc-sizes" alt="מטפל סיעודי מעניק יחס חם ואישי לקשיש בביתו ברחובות" className="w-full h-full object-cover" loading="eager" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -right-6 md:-bottom-10 md:-right-10 bg-card p-5 md:p-6 rounded-xl shadow-xl border border-border hidden sm:flex items-center gap-4 z-20 max-w-xs">
              <div className="bg-primary/10 p-3 md:p-4 rounded-lg shrink-0">
                <Clock className="w-6 h-6 md:w-8 md:h-8 text-primary" />
              </div>
              <div>
                <p className="font-bold text-foreground font-default text-base md:text-lg">הגעה מהירה</p>
                <p className="text-xs md:text-sm text-muted-foreground font-default">התחייבות לצוות תוך 5 שעות מרגע הפנייה</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}